import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Button, ButtonType } from "../../../Components/Button/Button";
import { ButtonFrameworkVariant } from "../../../Components/ButtonFramework/ButtonFramework";
import { mapRowsByProp } from "../../MetaBuyingUtils";
import * as R from "ramda";
import { DROPDOWN_BTN, SEARCH_MENU, AUDIENCE_SUBTYPE_MAP } from "../../MetaBuyingConstants";

interface CustomAudienceMenuProps {
  placeholder: string;
  menuId: string;
  data: Record<string, any>[];
  closeMenu: () => void;
  showMenu: boolean;
  applySelections: (value: number[]) => void;
  appliedSelections: number[];
  loading?: boolean;
}

export const CustomAudienceMenu = ({
  placeholder,
  menuId,
  data,
  closeMenu,
  showMenu,
  applySelections,
  appliedSelections,
}: CustomAudienceMenuProps): JSX.Element => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const dropdownBtnId = [menuId, DROPDOWN_BTN].join("_");
  const searchMenuId = [menuId, SEARCH_MENU].join("_");

  const idMap = mapRowsByProp("custom_audience_id", data);

  useEffect(() => {
    setSelectedIds(R.clone(appliedSelections));
  }, [showMenu, appliedSelections]);

  return (
    <div id={dropdownBtnId} className="metaBuyingSearchMenu menuToggle">
      <Button className="dropdown-toggle" type={ButtonType.OUTLINED}>
        {appliedSelections.length > 0 ? (
          appliedSelections.map((audienceId, index) => (
            <div
              key={index}
              className="appliedSelection"
              onClick={() => {
                const newAppliedSelections = R.remove(index, 1, appliedSelections);
                applySelections(newAppliedSelections);
                setSelectedIds(newAppliedSelections);
                closeMenu();
              }}
            >
              <span>{idMap[audienceId] ? idMap[audienceId].name : ""}</span>
            </div>
          ))
        ) : (
          <span className="searchMenuPlaceholder">{placeholder}</span>
        )}
      </Button>
      {showMenu && (
        <div id={searchMenuId} className="searchMenu menuToggle">
          {" "}
          <div>
            <Form.Control
              size="sm"
              className="searchBar"
              placeholder="Search"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <div className="searchMenuRows">
              {data
                .filter(({ name }) => new RegExp(searchQuery, "ig").test(name))
                .map((option, index) => (
                  <div key={index} className="searchMenuRow">
                    <Form.Check
                      className="searchMenuOption"
                      key={index}
                      type="checkbox"
                      label={option.name}
                      checked={R.includes(option.custom_audience_id, selectedIds)}
                      id={option.name}
                      onChange={() =>
                        setSelectedIds(
                          R.includes(option.custom_audience_id, selectedIds)
                            ? selectedIds.filter(id => id !== option.custom_audience_id)
                            : [...selectedIds, option.custom_audience_id]
                        )
                      }
                    />
                    <span>{AUDIENCE_SUBTYPE_MAP[option.subtype]}</span>
                  </div>
                ))}
            </div>
            <div className="searchMenuControls">
              <Button
                type={ButtonType.OUTLINED}
                variant={ButtonFrameworkVariant.NO_ICON}
                onClick={closeMenu}
              >
                Cancel
              </Button>
              <Button
                type={ButtonType.FILLED}
                variant={ButtonFrameworkVariant.NO_ICON}
                onClick={() => {
                  applySelections(selectedIds);
                  closeMenu();
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
